import React from "react";
import Loading from './../components/loading';
import { Fade } from 'react-reveal';
import MetaTags from 'react-meta-tags';
import styled from 'styled-components';
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Jumbotron from 'react-bootstrap/Jumbotron'
import Breadcrumb from 'react-bootstrap/Breadcrumb'
import Card from 'react-bootstrap/Card'
import Modal from 'react-bootstrap/Modal'
import Image from 'react-bootstrap/Image'
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLongArrowAltRight, faLongArrowAltLeft } from '@fortawesome/free-solid-svg-icons'

const ContentStyles = styled.div`
.projectGallery .card {
  border-radius: 0;
  cursor: pointer;
}
.projectGallery .card-img {
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
.projectStatus {
  color: #015099;
}
`;
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style }}
      onClick={onClick}
    >
      <FontAwesomeIcon size="lg" icon={faLongArrowAltRight} />
    </div>
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style }}
      onClick={onClick}
    >
      <FontAwesomeIcon size="lg" icon={faLongArrowAltLeft} />
    </div>
  );
}

class ProjectDetail extends React.Component {

  constructor(props) {
    super(props);
    this.handleShow = this.handleShow.bind(this);
    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      editTodo: {
        id: "",
        title: "",
        isCompleted: false
      },
      slideIndex: 0,
      slickGoTo: 0
    };
  }

  componentDidMount() {
    fetch("/json/konutlar.json?v=" + process.env.REACT_APP_SITE_VERSION)
      .then(res => res.json())
      .then(
        (result) => {
          this.setState({
            isLoaded: true,
            items: result
          });
        },
        (error) => {
          this.setState({
            isLoaded: true,
            error
          });
        }
      )
  }

  handleClose = () => {
    this.setState({ show: false });
  }

  handleShow = (a, b) => {
    this.setState({ show: true });
    this.setState({ slideIndex: a });
    this.setState({ slickGoTo: a });
    console.log(a);
  }

  setStatus = (a, b) => {
    this.setState({ projectStatus: "yeni" });
  }

  render() {
    const { error, isLoaded, items } = this.state;
    const { konutId } = this.props.match.params;
    if (error) {
      return <div>Error: {error.message}</div>;
    } else if (!isLoaded) {
      return <Loading />;
    } else {
      const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        lazyLoad: false,
        centerMode: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        adaptiveHeight: true,
        nextArrow: <SampleNextArrow />,
        prevArrow: <SamplePrevArrow />,
        slickGoTo: this.state.slickGoTo
      };
      return (
        <>
          <ContentStyles>
            {
              items.filter(projects => projects.guid === konutId)
                .map((projects, i) => {
                  const htmlString = projects.description;

                  let projectStatus;
                  if (projects.status === 1) {
                    projectStatus = "İnşaatı Devam Eden Proje";
                  } else if (projects.status === 2) {
                    projectStatus = "İnşaatı Tamamlanan Proje";
                  }

                  return (
                    <div key={i}>
                      <MetaTags>
                        <title>{projects.name} | Emlak Katılım Mortgage</title>
                        <meta name="description" content={projects.name} />
                        <meta property="og:title" content={`${projects.name} | Emlak Katılım Mortgage`} />
                        <meta property="og:image" content="" />
                      </MetaTags>
                      <Jumbotron className="subpageHeader" fluid>
                        <Fade>
                          <Container>
                            <h1>{projects.name}</h1>
                            <Breadcrumb>
                              <Breadcrumb.Item href="/">Ana Sayfa</Breadcrumb.Item>
                              <Breadcrumb.Item href="/anlasmali-konut-projeleri">
                                Anlaşmalı Konut Projeleri
                                        </Breadcrumb.Item>
                              <Breadcrumb.Item active>{projects.name}</Breadcrumb.Item>
                            </Breadcrumb>
                          </Container>
                        </Fade>
                      </Jumbotron>
                      <Container>
                        <Row>
                          <Col className="subpageContent">
                            <Fade bottom cascade>
                              <h2>{projects.name}</h2>
                              <h5 className="projectStatus">{projectStatus}</h5>
                              <article dangerouslySetInnerHTML={{ __html: htmlString }}></article>
                              <section className="projectGallery mt-5">
                                <h2>Proje Görselleri</h2>
                                <Row>
                                  {projects.images.map((images, i) => (
                                    <Col className="mb-4" md={3} key={i}>
                                      <Card className="bg-light text-white">
                                        <div onClick={() => { this.handleShow.call(this, images.id) }}>
                                          <Card.Img src={`/projects/${projects.guid}/${images.name}`} alt={projects.name} />
                                        </div>
                                      </Card>
                                    </Col>
                                  ))}
                                </Row>
                              </section>
                            </Fade>
                          </Col>
                        </Row>
                      </Container>
                      <Modal
                        dialogClassName="modalOfImages container"
                        aria-labelledby="contained-modal-title-vcenter"
                        centered
                        show={this.state.show}
                        onHide={this.handleClose}
                      >
                        <Modal.Body >
                          <Slider ref={slider => (this.slider = slider)} {...settings}>
                            {projects.images.map((images, i) => (
                              <div key={i}>
                                <Image className="projectSliderImage" src={`/projects/${projects.guid}/big/${images.name}`} alt={projects.name} fluid />
                              </div>
                            ))
                            }
                          </Slider>
                        </Modal.Body>
                      </Modal>
                    </div>
                  );
                })
            }
          </ContentStyles>
        </>
      );
    }
  }
}

export default ProjectDetail;